import {
  CLIENTES_GET_LISTA_DE_CLIENTES_BEGIN,
  CLIENTES_GET_LISTA_DE_CLIENTES_SUCCESS,
  CLIENTES_GET_LISTA_DE_CLIENTES_FAILURE,
  CLIENTES_GET_LISTA_DE_CLIENTES_DISMISS_ERROR
} from './constants';
import axios from 'axios'
import { getEndpoint } from '../../common/backend/endpoints'


export function getListaDeClientes(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CLIENTES_GET_LISTA_DE_CLIENTES_BEGIN,
    });

    const endpoint_clientes = getEndpoint('CLIENTES')
    const { queryString } = args

    const promise = new Promise((resolve, reject) => {
      // revert https://grupotagle.atlassian.net/browse/ID-92053
      // const searchOnlyByPhone = true
      const query = queryString ? `${queryString}&dinamicPagination=true` : '?dinamicPagination=true'
      // const doRequest = axios(`${endpoint_clientes}/${query}&searchOnlyByPhone=${searchOnlyByPhone}`)
      const doRequest = axios(endpoint_clientes+'/'+query)
      doRequest.then(
        (res) => {
          dispatch({
            type: CLIENTES_GET_LISTA_DE_CLIENTES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CLIENTES_GET_LISTA_DE_CLIENTES_FAILURE,
            data: { 
              error: err.response ? err.response.data.message.message : err.message
            },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetListaDeClientesError() {
  return {
    type: CLIENTES_GET_LISTA_DE_CLIENTES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLIENTES_GET_LISTA_DE_CLIENTES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getListaDeClientesPending: true,
        getListaDeClientesError: null,
      };
    case CLIENTES_GET_LISTA_DE_CLIENTES_SUCCESS:
      // The request is success
      return {
        ...state,
        dataList: action.data,
        getListaDeClientesPending: false,
        getListaDeClientesError: null,
      };

    case CLIENTES_GET_LISTA_DE_CLIENTES_FAILURE:
      // The request is failed
      return {
        ...state,
        getListaDeClientesPending: false,
        getListaDeClientesError: action.data.error,
      };

    case CLIENTES_GET_LISTA_DE_CLIENTES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getListaDeClientesError: null,
      };

    default:
      return state;
  }
}
